import { libsAssetManifestSriHashes } from './libs';

// 先获取html所有子包对应的sri映射数据
const assetManifestSriHashes = window.assetManifestSriHashes ?? {};

// 然后合并汇总管理
window.libsAssetManifestSriHashes = Object.assign(libsAssetManifestSriHashes, assetManifestSriHashes);
